import React from 'react';
import { useSelector } from "../../../util/store/store";
import { IOperation2 } from "../../../util/varibles/interface";
import LoadingBox from "../../LoadingBox";

interface IProps {
    data: IOperation2[]
}

const Loading: React.FC<IProps> = ({ data }) => {
    const loading = useSelector(state => state.login.loadingDashboard);
    if (!loading && data.length > 0)
        return null

    return <LoadingBox loading={loading} message="There is no operation coming." />;
};

export default Loading;
